/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
// import { FaHandHoldingDollar } from "react-icons/fa6";
import axiosInstance from "../../Axois/Axois";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
// import { NavLink } from "react-router-dom";

const SEctionTwo = () => {
  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "UK",
    "US",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  const [csp, setcsp] = useState([]);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [cspid, setCspid] = useState("");
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    contact: "",
    email: "",
    requirement: "",
  });
  useEffect(() => {
    axiosInstance
      .get("/all/country")
      .then((res) => {})
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handlegetcsp = async (e) => {
    const { value } = e.target;
    await axiosInstance
      .get(`/all/csp?country=${value}`)
      .then((res) => {
        if (res.data.status === true) {
          setcsp(res.data.data);
          toast.success(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };
  const handleSubmit = async (event) => {
    console.log(cspid, "cspid");
    event.preventDefault();
    setLoading(true);
    try {
      const fromdatatosend = new FormData();
      fromdatatosend.append("fname", formData.fname);
      fromdatatosend.append("lname", formData.lname);
      fromdatatosend.append("phone", formData.contact);
      fromdatatosend.append("email", formData.email);
      fromdatatosend.append("business", formData.requirement);
      fromdatatosend.append("csp_id", cspid);
      await axiosInstance
        .post("/borrower-request", fromdatatosend)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            setCspid("");
            setcsp([]);

            setFormData({
              fname: "",
              lname: "",
              contact: "",
              email: "",
              requirement: "",
            });
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container mt-40">
      <Toaster position="top-right" reverseOrder={false} />
      <h1 className="text-center">Start your borrower application</h1>
      <p className="text-center">join to help your community</p>
      <Link to={"/login"}>
        {/* <div className="row justify-content-center gap-3 mb-4">
        <button className="col-lg-2 col-md-4 col-5 btn btn-warning registerBtn text-light">
          Register
        </button>
      </div> */}
      </Link>
      <div className="row py-4">
        <div
          className="d-flex flex-column justify-content-center align-items-center col-lg-6 col-md-6 "
          style={{ paddingLeft: "20px" }}
        >
          <div className="col-12 d-flex justify-content-center align-items-center">
            <p
              style={{ color: "#ffc107", fontSize: "24px", fontWeight: "600" }}
            >
              How to apply for a loan
            </p>
          </div>
          <p className=" cspP">
            On the entrepreneur profiles page, you will meet small business
            starters or owners, who have demonstrated to their local Community
            Service Partner (CSP) that they have a genuine business need and a
            viable plan to repay their business loan to the Share-Circle
            Community Lending Platform
          </p>
          <p>
            As these funds are repaid, they become available for re-investment
            or re-lending to other business entrepreneurs.
          </p>
          <p>
            So as a responsible borrower, repayment of your loan, will continue
            to support others by being lent out again, as part of a “Fund raise”
            for someone else.
          </p>
        </div>
        <div className="col-lg-6  col-md-6 col-12">
          <h6 className="mx-auto mb-3 fs-4 px-5 fw-bold text-center">
            Start by selecting your CSP and country
          </h6>

          <div className="form1232 my-5">
            <form onSubmit={handleSubmit}>
              <select
                onChange={(e) => handlegetcsp(e)}
                className="col-12 px-3 mb-3 rounded Formselect11"
                style={{ height: "50px" }}
              >
                <option>select Country</option>
                {countries.map((country, index) => (
                  <option key={index}>{country}</option>
                ))}
              </select>
              <select
                className=" col-12 px-3 mt-3 rounded Formselect11"
                style={{ height: "50px" }}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setCspid(selectedValue);
                }}
              >
                <option>Select CSP</option>
                {csp?.map((data, index) => {
                  return (
                    <>
                      <option value={data.id} key={index}>
                        {data.name}
                      </option>
                    </>
                  );
                })}
              </select>
              <div>
                {/* <label>First Name:</label> */}
                <input
                  type="text"
                  name="fname"
                  value={formData.fname}
                  placeholder="First Name"
                  onChange={handleInputChange}
                  required
                  className="mb-3 forminput11"
                />
              </div>
              <div>
                {/* <label>Last Name:</label> */}
                <input
                  type="text"
                  name="lname"
                  placeholder="Last Name"
                  value={formData.lname}
                  onChange={handleInputChange}
                  required
                  className="mb-3 forminput11"
                />
              </div>
              <div>
                {/* <label>Phone No:</label> */}
                <input
                  type="text"
                  name="contact"
                  placeholder="Phone No"
                  value={formData.contact}
                  onChange={handleInputChange}
                  required
                  className="mb-3 forminput11"
                />
              </div>

              <div>
                {/* <label>Email:</label> */}
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="mb-3 forminput11"
                />
              </div>
              <div>
                {/* <label>Business:</label> */}
                <input
                  type="text"
                  name="requirement"
                  placeholder="Business"
                  value={formData.requirement}
                  onChange={handleInputChange}
                  required
                  className="mb-3 forminput11"
                />
              </div>
              <button
                style={{
                  backgroundColor: "#ffa500",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                type="submit"
                className="arrow-icon"
              >
                {loading ? (
                  "Loading..."
                ) : (
                  <>
                    Submit &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="">
                      <img src="../images/icon.png" alt="" />
                    </span>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SEctionTwo;
